import {
  INIT, SUCCESS, LOADING, ERROR,
} from '../../../utils/constants';
import {
  GET_BILL_AZURE, GET_BILL_AZURE_SUCCESS, GET_BILL_AZURE_ERROR
} from './constant';


const initialState = {
  phase: INIT,
  azureBillList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */
 

export function AzureBillStore(state = initialState, action) {
  switch (action.type) {
    case GET_BILL_AZURE:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_BILL_AZURE_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureBillList: action.data,
        error: null,
      };
    case GET_BILL_AZURE_ERROR:
      return { ...state, phase: ERROR, error: action.error };





    default:
      return state;
  }
}
